import axios from 'axios';

const TIMEOUT_MESSAGE = 'Сервер не ответил вовремя. Проверьте соединение и попробуйте ещё раз.';
const NETWORK_MESSAGE = 'Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.';
const RATE_LIMIT_MESSAGE = 'Слишком много попыток. Подождите минуту и попробуйте снова.';
const SERVER_MESSAGE = 'Ошибка на сервере. Попробуйте ещё раз чуть позже.';

const CYRILLIC = /[А-Яа-яЁё]/;

/** HTTP-статус ответа, если ошибка пришла от сервера */
export function getApiErrorStatus(err: unknown): number | undefined {
  return axios.isAxiosError(err) ? err.response?.status : undefined;
}

/**
 * Текст ошибки для пользователя. Текст бэкенда показываем только если он
 * на русском: сырой английский до пользователя доходить не должен.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (!axios.isAxiosError(err)) return fallback;

  if (!err.response) {
    return err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT'
      ? TIMEOUT_MESSAGE
      : NETWORK_MESSAGE;
  }

  // data может оказаться строкой (HTML от nginx при 502), а не JSON
  const data: unknown = err.response.data;
  const apiError =
    data !== null && typeof data === 'object' ? (data as { error?: unknown }).error : undefined;
  if (typeof apiError === 'string' && CYRILLIC.test(apiError)) return apiError;

  const status = err.response.status;
  if (status === 429) return RATE_LIMIT_MESSAGE;
  if (status >= 500) return SERVER_MESSAGE;

  return fallback;
}
